export default axios => ({
    getDynamics (payLoad) {
        return axios.get(`/visit/dynamics`, payLoad);
    },
    getDiagnosticTable (payLoad) {
        return axios.get(`/visit/diagnostic-table`, payLoad);
    },
})